module.exports = __webpack_public_path__ + "media/images/web_suite/icon_desktop-5de123277f42b69f17bc8df84ce34832.png";